import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Stack } from '@chakra-ui/react';
import {
  useLocalStorage,
  useResendCode,
  useTimer,
  useVerification,
} from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import {
  AuthSuggestion,
  DesktopAuthHeader,
  SERVICE_CARD_BORDER_RADIUS,
} from 'components';

import { Form } from './components';

const Verification: React.FC = () => {
  const { t } = useTranslation('component.auth.verification');
  const { counter, setCounter } = useTimer(120);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setItem } = useLocalStorage();

  React.useEffect(() => {
    if (!searchParams.get('username') || !searchParams.get('token')) {
      navigate(routes.auth.signIn.url);
    }
  }, [navigate, searchParams]);

  const token = searchParams.get('token') || '';

  const { mutateAsync: submit, isPending: isVerifying } =
    useVerification(token);

  const { mutateAsync: resend, isPending: isResending } = useResendCode(token);

  return (
    <Stack w="100%" align="stretch" gap={{ base: 6, md: 8 }}>
      <DesktopAuthHeader title={t('verificationToMagix')} titleAlign="center" />
      <Box
        bg="dark"
        borderWidth="1px"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        px={{ base: 5, md: 7 }}
        py={{ base: 6, md: 8 }}
        w="100%"
      >
        <Form
          isVerifying={isVerifying}
          isResending={isResending}
          onButton={(data) =>
            submit({
              code: data.code,
              username: searchParams.get('username') || '',
            }).then((res: { access_token: string }) => {
              if (res?.access_token) {
                setItem('magix-token', res.access_token);
                const returnUrl = searchParams.get('return_url') || '';
                const systemId = searchParams.get('system_identifier');
                const systemQs = systemId
                  ? `&system_identifier=${systemId}`
                  : '';
                navigate(
                  `${routes.dashboard.url}?return_url=${returnUrl}${systemQs}`
                );
              }
            })
          }
          counter={counter}
          resendCode={() =>
            resend({ username: searchParams.get('username') || '' }).then(
              () => {
                setCounter(120);
              }
            )
          }
        />
      </Box>
      <AuthSuggestion include={['forget-password', 'sign-up']} />
    </Stack>
  );
};

export default Verification;
